import { INIT_MAP_MARKERS, CLEAR_MAP_MARKERS } from '../type';

export function mapMarkersReducer(state = [], action) {
  const { type, payload } = action;

  switch (type) {
    case INIT_MAP_MARKERS:
      return payload || [];

    case CLEAR_MAP_MARKERS:
      return [];

    default:
      return state;
  }
}
